import { h } from "@stencil/core";

export function ImageZapEmptyState() {
  return (
    <svg
      aria-hidden="true"
      width="400"
      height="230"
      viewBox="0 0 400 230"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" y="0.5" width="399" height="99" rx="4.5" stroke="#D7D5D2" />
      <rect x="20" y="20" width="60" height="60" rx="5" fill="#F7F5F2" />
      <rect x="97" y="26" width="119" height="24" rx="4" fill="#F7F5F2" />
      <rect x="97" y="60" width="199" height="14" rx="4" fill="#F7F5F2" />
      <rect
        x="0.5"
        y="130.5"
        width="399"
        height="99"
        rx="4.5"
        stroke="#D7D5D2"
      />
      <rect x="20" y="150" width="60" height="60" rx="5" fill="#F7F5F2" />
      <rect x="97" y="156" width="119" height="24" rx="4" fill="#F7F5F2" />
      <rect x="97" y="190" width="199" height="14" rx="4" fill="#F7F5F2" />
      <line
        x1="201"
        y1="103"
        x2="201"
        y2="127"
        stroke="#403F3E"
        stroke-width="2"
      />
    </svg>
  );
}
